module.exports = __webpack_public_path__ + "static/media/cookie.61f0c7bd.svg";